import { GET_WS, GET_WS_SUCCESS, GET_WS_ERROR} from './actionTypes';

const initialState = {
    errorGetWs: "",
    loadingGetWs: false,
    ws: null,
    successWs: ""
}

const getWorkstations = (state = initialState, action) => {
    switch (action.type) {
        case GET_WS:
            state = {
                ...state,
                loadingGetWs: true
            }
            break;
        case GET_WS_SUCCESS:
            state = {
                ...state,
                loadingGetWs: false,
                ws: action.payload.ws, 
                successWs: action.payload.message
            }
            break;
        case GET_WS_ERROR:
            state = { ...state, errorGetWs: action.payload, loadingGetWs: false };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
}

export default getWorkstations;